const getters = {
  inputs: state => state.inputs,
  input: state => state.input,
  inputFilters: state => state.input_filters,
}

export default getters;
